const s = {
  name: "CurrencyGeneric",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M15.1,23.5l-2.8,2.8l1.4,1.4l2.8-2.8c1,0.7,2.2,1.1,3.5,1.1s2.5-0.4,3.5-1.1l2.8,2.8l1.4-1.4l-2.8-2.8
			c0.7-1,1.1-2.2,1.1-3.5s-0.4-2.5-1.1-3.5l2.8-2.8l-1.4-1.4l-2.8,2.8c-1-0.7-2.2-1.1-3.5-1.1c-1.3,0-2.5,0.4-3.5,1.1l-2.8-2.8
			l-1.4,1.4l2.8,2.8c-0.7,1-1.1,2.2-1.1,3.5S14.4,22.5,15.1,23.5z M16,20c0-1.1,0.4-2.1,1.2-2.8c0.7-0.7,1.7-1.2,2.8-1.2
			s2.1,0.4,2.8,1.2c0.7,0.7,1.2,1.7,1.2,2.8s-0.4,2.1-1.2,2.8C22.1,23.6,21.1,24,20,24s-2.1-0.4-2.8-1.2C16.5,22.1,16,21.1,16,20z"
			/>
		<path class="st0" d="M20,0C9,0,0,9,0,20c0,11,9,20,20,20c11,0,20-9,20-20C40,9,31.1,0,20,0z M2,20c0-9.9,8.1-18,18-18
			c9.9,0,18,8.1,18,18s-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CurrencyGeneric
};
